<template>
    <div class="detail-card">
        <div class="card-image">
            <video
                v-if="res.try_listen"
                class="card-image__cover"
                style="objectFit: cover"
                autoPlay="autoplay"
                muted
                :poster="res.cover_url"
                controls
                controlslist="nodownload"
                webkit-playsinline="true"
                x-webkit-airplay="allow"
                x5-video-player-type="h5"
                playsinline="true"
                :src="res.try_listen"
            ></video>
            <div
                v-else-if="res.cover_url"
                class="card-image__cover lazy-img-fadein"
            >
                <img :src="res.cover_url" alt="班级详情图" class="banner" @load="onImageLoad">
                <img
                    :src="res.cover_url"
                    class="perf-log-img"
                    onload="window.__detailFirstImage__load = Date.now();"
                >
            </div>
            <div
                v-else
                class="card-image__cover lazy-img-fadein"
            >
                <img :src="teacherInfo.image_photo_url" alt="老师展示图" class="teacher"@load="onImageLoad">
                <img
                    :src="teacherInfo.image_photo_url"
                    class="perf-log-img"
                    onload="window.__detailFirstImage__load = Date.now();"
                >
            </div>
        </div>
        <div :class="{'stop-img': stopSaleStatus}" class="card-info">
            <div class="card-classify">
                <span v-if="res.season && res.display_detail!=1" class="season">{{res.season}}</span>
                <span v-if="res.biz_type !== 2" class="subject">
                    <template v-if="res.title_subject">{{res.title_subject}}</template>
                    <template v-else>{{res.subject_full_name}}</template>
                </span>
                <span class="title">{{res.title}}</span>
            </div>
            <!-- 增加难度等级 -->
            <difficultyLevel :card="res" />
            <div v-if="res.display_detail!=1" class="card-begin ellipsis">
                <span class="card-begin__time">{{res.introduction}}</span>
                <em v-if="res.introduction && res.lecture_desc" class="card-begin__line">|</em>
                <span
                    v-if="res.lecture_desc"
                    class="card-begin__hour"
                >共{{res.lecture_desc}}</span>
            </div>
            <div v-if="res.display_detail!=1" class="card-teacher clearfix">
                <img class="arrow-left" :class="{hide: !moveTeacherItem}" src="https://hks.gsxcdn.com/1534447862_wzkykuhh.jpg" alt="" @click="minusIndex">
                <div class="teacher-carousel" :style="{'left': moveTeacherItem * TEACHER_ITEM_WIDTH + 'px'}">
                    <div
                        v-for="(item, index) in teacher_list"
                        :key="index"
                        v-clickReport="36084139"
                        class="teacher clearfix"
                        :class="{'teacher-head': item.teacher_type !== 1, 'disabled': isGtqscz}"
                        @click="gotoTeacherDetail(item)"
                    >
                        <div class="teacher-left">
                            <div class="teacher__icon">
                                <webp-image :src="item.teacher_icon" width="80" height="80" />
                            </div>
                        </div>
                        <div class="teacher-right">
                            <div class="teacher__name ellipsis">{{item.teacher_name}}</div>
                            <div class="teacher__text">{{item.teacher_role || '主讲老师'}}</div>
                        </div>
                    </div>
                </div>
                <img class="arrow-right" :class="{hide: moveTeacherItem <= -teacher_list.length + ITEM_PAGE_SIZE}" src="https://hks.gsxcdn.com/1534447862_wzkykuhh.jpg" alt="" @click="addIndex">
            </div>
        </div>
    </div>
</template>
<script>
import {reportPerformance} from '@base/util/performance';
import webpImage from '@business/components/common/webpImage';
import difficultyLevel from '@business/components/common/DifficultyLevel';
import {mapState} from 'vuex';
import config from '~/environment';
import productAction from '@base/mixins/productAction';

export default {
    name: 'DetailCard',
    components: {
        difficultyLevel,
        'webp-image': webpImage
    },
    mixins: [productAction],
    props: {
        res: {
            type: Object,
            default() {
                return {};
            }
        },
        fromIndex: {
            type: Boolean,
            default: false
        },
        stopSaleStatus: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            TEACHER_ITEM_WIDTH: 134,
            ITEM_PAGE_SIZE: 3,
            moveTeacherItem: 0,
            teacherImg: {
                teacher_icon: 'https://p.gsxcdn.com/620451512_6acin7lc.png'
            },
            teacher_list: [],
        };
    },
    computed: {
        ...mapState({
            p_client: state => state.p_client
        }),
        // 主讲老师信息
        teacherInfo() {
            const {teacher_info_vo = {}} = this.res;
            return teacher_info_vo;
        }
    },
    created() {
        const {counselor_icon, counselor_name, counselor_id, teacher_list, counselor_role} = this.res;
        this.teacher_list = [
            ...teacher_list, {
                teacher_icon: counselor_icon,
                teacher_name: counselor_name,
                teacher_number: counselor_id,
                teacher_role: counselor_role || '二讲老师',
                teacher_type: 1
            }
        ];
    },
    methods: {
        gotoTeacherDetail({teacher_number, teacher_type}) {
            if(this.isGtqscz) {
                return;
            }
            if (teacher_number && teacher_type !== 1) {
                if (this.p_client === 12) {
                    window.open(`https:${config.env.pcUrl}/teacher/detail/${teacher_number}`);
                }
                else {
                    this.$router.push({
                        path: `/teacher/detail/${teacher_number}`
                    });
                }
            }
        },
        // 图片加载完成后的计算时间
        onImageLoad() {
            if (!this.fromIndex) {
                return;
            }
            try {
                const extra = {};
                const start = window.performance.timing.navigationStart;
                if (window.__detailFirstImage__load) {
                    extra.fip = window.__detailFirstImage__load - start;
                }
                if (this.res.fr) {
                    extra.fr = this.res.fr;
                }
                reportPerformance(extra);
            }
            catch (e) {
                console.error(e);
            }
        },
        // 右滑
        minusIndex() {
            if (this.moveTeacherItem < 0) {
                this.moveTeacherItem++;
            }
        },
        // 左滑
        addIndex() {
            if (this.moveTeacherItem > -this.teacher_list.length + this.ITEM_PAGE_SIZE) {
                this.moveTeacherItem--;
            }
        }
    }
};
</script>
<style lang="less" scoped>
.disabled {
    cursor: default !important;
}
.detail-card {
    position: relative;
    background-color: #fff;
    border-radius: 4px;
    border: solid 1px #ebebeb;
    padding: 30px 0 30px 30px;
    height: 190px;

    .card-image {
        float: left;
        width: 304px;
        height: 100%;

        &__cover {
            position: relative;
            width: 100%;
            height: 170px;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            border-radius: 4px;
        }
        img.banner {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        img.teacher{
            width: 145px;
            height: 185px;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%, 0);
        }
        .perf-log-img {
            width: 0;
            height: 0;
        }
    }
}

.card-info {
    position: relative;
    margin-left: 324px;

    .card-classify {
        position: relative;
        font-size: 0;
        margin-bottom: 12px;
        padding-right: 90px;

        span {
            font-size: 14px;
            vertical-align: middle;

            &.season {
                display: inline-block;
                background-color: #f63232;
                border-radius: 2px;
                padding: 3px;
                border: solid 1px #f63232;
                color: #fff;
                margin-right: 6px;
            }

            &.subject {
                display: inline-block;
                border-radius: 2px;
                padding: 3px 4px;
                margin-right: 6px;
                color: #f63232;
                border: solid 1px #f63232;
            }

            &.title {
                margin: 0;
                font-size: 20px;
                line-height: 28px;
                height: 48px;
                margin-bottom: 12px;
                color: #32404b;
                font-weight: 400;
                word-break: break-all;
            }
        }
    }

    .card-begin {
        position: relative;
        font-size: 16px;
        color: #818a92;
        padding-right: 32px;
        margin-bottom: 20px;

        &__line {
            font-style: normal;
            padding: 0 10px;
            vertical-align: top;
        }
    }

    .card-teacher {
        width: 402px;
        overflow: hidden;
        position: relative;
        left: -20px;
        padding-left: 25px;

        & > img {
            position: absolute;
            width: 20px;
            height: 20px;
            cursor: pointer;
            z-index: 100;
        }

        .arrow-left {
            top: 12px;
            left: 0;
            transform: rotate(270deg);
        }

        .arrow-right {
            top: 12px;
            right: 0;
            transform: rotate(90deg);
        }

        .teacher-head {
            cursor: pointer;
        }

        .teacher-carousel {
            overflow: hidden;
            position: relative;
            width: 2000px;
        }

        .hide {
            display: none;
        }

        .teacher {
            display: inline-block;
            margin-right: 20px;
            width: 114px;

            &__name {
                font-size: 14px;
                color: #32404b;
                margin-bottom: 8px;
            }

            &__text {
                font-size: 12px;
                color: #818a92;
            }

            &-left {
                float: left;
            }

            &-right {
                float: left;
                box-sizing: border-box;
                padding: 5px 0 0 10px;
                width: 72px;
                text-align: left;
            }

            &__icon {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                background: #ebebeb url(~assets/img/preview-icon.png) no-repeat center center;
                background-size: 55%;
                border: 1px solid #f5f5f5;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                }
            }
        }
    }

    .card-left-count {
        float: left;
        position: relative;
        margin-left: -6px;
        height: 24px;
        line-height: 24px;
        padding: 0 10px;
        font-size: 12px;
        color: #fff;
        background-color: #ff777c;
        border-radius: 12px;

        &::before {
            content: "";
            position: absolute;
            right: 100%;
            bottom: -2px;
            width: 6px;
            height: 6px;
            border-width: 0;
            border-style: solid;
            border-color: transparent;
            margin-right: -4px;
            border-top-width: 6px;
            border-top-color: currentColor;
            border-radius: 6px 0 0;
            color: #ff777c;
        }
    }
}

.stop-img {
    position: relative;

    &::after {
        content: " ";
        position: absolute;
        right: 40px;
        bottom: -10px;
        width: 90px;
        height: 90px;
        background: url(~assets/img/stop-course.png) no-repeat no-repeat;
        background-size: 100% 100%;
    }
}
</style>
